export { default } from 'Features/FilterBar/FilterBarConnector';
